var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.707 4l6 6-6 6L7 15.293 12.293 10 7 4.707 7.707 4z",
    fill: "#000"
  })));
}
export default "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg id='Icons / Arrows / ChevronRight'%3e %3cpath id='Glyph' fill-rule='evenodd' clip-rule='evenodd' d='M7.70703 4L13.707 10L7.70703 16L7.00003 15.293L12.293 10L7.00003 4.707L7.70703 4Z' fill='black'/%3e %3c/g%3e %3c/svg%3e";
export { SvgChevronRight as ReactComponent };